<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Wesley Boff is the pseudonym of Dr Terry Moore. He spent his medical career in South Yorkshire working as a family doctor and for almost thirty years, he contracted to provide forensic physician services to his local police force. He lives in Florida.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?ee7a7900